module.exports = __webpack_public_path__ + "static/img/cpzx_nav_3@2x.19e02e9a.png";